/* TIMELESS MOONLIGHT MELTS — launch announcement bar.

   Built in JS and inserted AFTER the header's shopify-section so it sits in
   normal flow between the menu and the page, then position: sticky (see the
   CSS) keeps it pinned just beneath the sticky header on scroll.

   TWO WORDINGS ship in the markup and the stylesheet shows one at a time. The
   full sentence is for desktop; phones get a short one so the bar stays a
   single line instead of wrapping to three and eating the top of the hero.

   The code itself is a button — click, and NEWSITE15 is on the clipboard.
   The "Copied ✓" flash is deliberately NOT gated on the clipboard promise:
   navigator.clipboard.writeText can hang without resolving when the document
   is not focused, and feedback that sometimes never arrives is worse than
   feedback that is occasionally optimistic. Flip the label first, then try
   both copy routes.

   Dismissal lasts the browsing session only: a launch offer should come back
   tomorrow, but nobody needs to close it twice in one visit. */
(function () {
  'use strict';

  var CODE = 'NEWSITE15';
  var KEY = 'tmm-launch-hide';

  try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}

  function copy(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function () {});
      }
    } catch (e) {}
    try {
      var t = document.createElement('textarea');
      t.value = text;
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);
    } catch (e) {}
  }

  function build() {
    if (document.querySelector('.tmm-launch')) return;

    var hdr = document.querySelector('header.header') || document.querySelector('header');
    if (!hdr) return;
    var sect = hdr.closest('[id^="shopify-section"]') || hdr;

    var bar = document.createElement('div');
    bar.className = 'tmm-launch';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Announcement');
    bar.innerHTML =
      '<div class="tmm-launch__inner">' +
        '<span class="tmm-launch__spark" aria-hidden="true">✦</span>' +
        '<span class="tmm-launch__msg tmm-launch__msg--full">' +
          '<strong>The new site is here!</strong>&nbsp; Celebrate with <strong>15% off everything</strong> —' +
        '</span>' +
        '<span class="tmm-launch__msg tmm-launch__msg--short">' +
          '<strong>New site!</strong> <strong>15% off</strong> with' +
        '</span>' +
        '<button type="button" class="tmm-launch__code" aria-label="Copy discount code ' + CODE + '">' +
          CODE +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">' +
            '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="tmm-launch__close" aria-label="Dismiss announcement">✕</button>' +
      '</div>';

    sect.insertAdjacentElement('afterend', bar);

    var pill = bar.querySelector('.tmm-launch__code');
    var label = pill.childNodes[0];
    var timer = null;
    pill.addEventListener('click', function () {
      copy(CODE);
      pill.classList.add('is-copied');
      label.nodeValue = 'Copied ✓';
      clearTimeout(timer);
      timer = setTimeout(function () {
        pill.classList.remove('is-copied');
        label.nodeValue = CODE;
      }, 1600);
    });

    bar.querySelector('.tmm-launch__close').addEventListener('click', function () {
      bar.remove();
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
